import React from 'react';

import PropTypes from 'prop-types';

import { EstimatedDeliveryTime } from '../../components/services/estimated-delivery-time';
import { UserDateTimezoneFormat } from '../../components/user-date-timezone-format';
import { UserDateTimePropType } from '../../prop-types/user-date-time';
import { isValidISOString } from '../../services/time-helper-service';

export const DeliveryTime = ({ className, deliveryTime, emptyValue }) => {
  const isValidISO = isValidISOString(deliveryTime);

  return isValidISO ? (
    <span className={className}>
      <UserDateTimezoneFormat dateTime={deliveryTime} showTime spaceBetweenTimeAndZone />
    </span>
  ) : (
    <EstimatedDeliveryTime estimatedDeliveryTime={deliveryTime}>
      {({ normalizedDeliveryTime }) => <span className={className}>{normalizedDeliveryTime || emptyValue}</span>}
    </EstimatedDeliveryTime>
  );
};

DeliveryTime.propTypes = {
  className: PropTypes.string,
  deliveryTime: UserDateTimePropType,
  emptyValue: PropTypes.node,
};
